import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { LoadStatus } from '../../load-status';
import {
    SOFTWARE_LICENCES_FEATURE_KEY,
    SoftwareLicencesCollectionState,
    SoftwareLicencesEntry,
    SoftwareLicenceState,
} from '../software-licences-collection.state';

export const selectSoftwareLicencesFeature =
    createFeatureSelector<SoftwareLicencesCollectionState>(SOFTWARE_LICENCES_FEATURE_KEY);

export const selectSoftwareLicencesKeys = createSelector(selectSoftwareLicencesFeature, (state) =>
    Object.keys(state.licences),
);
export const selectSoftwareLicencesEntry = (
    equipmentKey: string,
): MemoizedSelector<object, SoftwareLicencesEntry | undefined> =>
    createSelector(selectSoftwareLicencesFeature, (state) => state.licences[equipmentKey]);

export const selectSoftwareLicencesDataForEquipment = (
    equipmentKey: string,
): MemoizedSelector<object, SoftwareLicenceState[]> =>
    createSelector(selectSoftwareLicencesFeature, (state) => state.licences[equipmentKey]?.data ?? []);

export const selectSoftwareLicencesStatusForEquipment = (equipmentKey: string): MemoizedSelector<object, LoadStatus> =>
    createSelector(selectSoftwareLicencesFeature, (state) => state.licences[equipmentKey]?.status ?? LoadStatus.Idle);

export const selectSoftwareLicences = createSelector(selectSoftwareLicencesFeature, (state) => {
    const persistedState: Record<string, SoftwareLicenceState[]> = {};

    Object.entries(state.licences).forEach(([equipmentKey, entry]) => {
        persistedState[equipmentKey] = entry.data;
    });

    return persistedState;
});

export const selectSoftwareLicencesLoaded = createSelector(selectSoftwareLicencesFeature, (state) => {
    return Object.values(state.licences).every((entry) => entry.status === LoadStatus.Loaded);
});
